import React from 'react';
import './FusionContentRenderer.css';

const FusionContentRenderer = ({ htmlContent, className = "" }) => {
    return (
        <div 
            className={`fusion-content-wrapper ${className}`}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
    );
};

export default FusionContentRenderer;
